import React from 'react';
import { Container } from 'reactstrap';

//Import Breadcrumb
import Breadcrumbs from "../../../components/Common/Breadcrumb";
import JSONTools from '../../../components/Utils/JSONTools';

const JSONToolsView = () => {
    document.title = "JSON Tools | UI - Defender";

    return (
        <React.Fragment>
                <div>
                    <Container fluid={true}>
                        <Breadcrumbs items={[
                            {chave: "UI Lab", transacao: "ui"},
                            {chave: "JSON Tools", transacao: "json-tools"},
                            ]} transactionCode="json-tools" transactionDescribe="JSON Tools" />
                        <JSONTools />
                    </Container>
                </div>
        </React.Fragment>
    );
}

export default JSONToolsView;